export const GOOGLE_MAPS_API_KEY = (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '').trim();

export const isGoogleMapsConfigured = () => GOOGLE_MAPS_API_KEY.length > 0;
